<accredible-base-footer *transloco="let t; lang: 'en|static' read: 'directory_fluencetraining_com.footer'">
  <div class="content">
    <div class="logo-social-container">
      <a target="_blank"
        [attr.aria-label]="t('aria_issuer_link')"
        href="https://www.fluencetraining.com/">
        <img [alt]="t('issuer_logo')"
          class="branding-logo"
          src="/assets/themes/directory.fluencetraining.com/images/footer_logo.png">
      </a>

      <div class="social-links">
        <a href="https://www.linkedin.com/school/fluencetraining/"
          target="_blank">
          <img src="/assets/themes/directory.fluencetraining.com/images/linkedIn.svg">
        </a>

        <a href="https://www.instagram.com/fluencetraining/"
          target="_blank">
          <img src="/assets/themes/directory.fluencetraining.com/images/instagram.svg">
        </a>

        <a href="https://www.youtube.com/@fluence2778"
          target="_blank">
          <img src="/assets/themes/directory.fluencetraining.com/images/youtube.svg">
        </a>
      </div>
    </div>
  </div>
</accredible-base-footer>
